import styled, { css } from 'styled-components';

interface StyledCurrencyAvatarProps {
    $invertTheme?: boolean;
    $size?: number;
}

export const StyledCurrencyAvatar = styled.div<StyledCurrencyAvatarProps>`
    --currency-avatar-color: white;
    --currency-avatar-bg: rgb(255, 255, 255, 0.1);

    display: grid;
    place-items: center;
    place-content: center;
    flex: 0 0 auto;
    width: 1em;
    height: 1em;
    font-size: ${({ $size }) => $size}px;
    color: var(--currency-avatar-color);
    background-color: var(--currency-avatar-bg);
    border-radius: 999px;

    ${({ $invertTheme }) =>
        $invertTheme &&
        css`
            --currency-avatar-color: black;
            --currency-avatar-bg: rgb(0, 0, 0, 0.1);
        `};
`;

export const IconWrapper = styled.div`
    width: 0.72em;
    height: 0.72em;
`;
